import { render, staticRenderFns } from "./LeaseSetupNew.vue?vue&type=template&id=3ca3e1bd&scoped=true"
import script from "./LeaseSetupNew.vue?vue&type=script&lang=js"
export * from "./LeaseSetupNew.vue?vue&type=script&lang=js"
import style0 from "./LeaseSetupNew.vue?vue&type=style&index=0&id=3ca3e1bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca3e1bd",
  null
  
)

export default component.exports